(function () {
  function kgMoveRequestPriceModal(modal) {
    if (!modal || modal.parentElement === document.body) return;
    modal.moved = false;
    document.body.appendChild(modal);
  }

  function kgPrepareRequestPriceModal(opener) {
    var selector = opener.getAttribute('data-modal');
    if (!selector) return;

    var modal = document.querySelector(selector);
    if (!modal) {
      var template = document.querySelector(selector + '-template');
      if (!template || !template.content) return;
      document.body.appendChild(template.content.cloneNode(true));
      return;
    }

    kgMoveRequestPriceModal(modal);
  }

  function kgMoveAllRequestPriceModals() {
    document.querySelectorAll('modal-dialog.kg-request-price-modal').forEach(kgMoveRequestPriceModal);
  }

  document.addEventListener(
    'click',
    function (event) {
      var opener = event.target.closest('.kg-request-price__opener');
      if (!opener) return;
      kgPrepareRequestPriceModal(opener);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kgMoveAllRequestPriceModals);
  } else {
    kgMoveAllRequestPriceModals();
  }

  document.addEventListener('shopify:section:load', kgMoveAllRequestPriceModals);
})();
